import ROLES from '../../roles'

export default {
  /**
     * @path http://localhost:8081/#/bulldings
     * Prevent user from adding/view/modifying/updating buildings
     */
  CAN_ADD_ADMIN_TAB: [ROLES.ADMIN], // this roles can only view, no other operations
  CAN_NOT_ADD_FIELD_OR_STAFF_TAB: [ROLES.TOW_COMPANY], // this roles can only view, no other operations
  CAN_VIEW_ONLY: [ROLES.PB_FIELD_AGENT, ROLES.TOW_DRIVER], // this roles can only view, no other operations
  CAN_GLOBAL_SEARCH: [ROLES.ADMIN, ROLES.SALES, ROLES.TOW_COMPANY, ROLES.TOW_DRIVER], // this roles can view and use the global search in dashboard
  CAN_SEE_SETTINGS: [ROLES.ADMIN],
  CAN_SEE_RECENT_PROPERTIES: [ROLES.ADMIN]
}



// WEBPACK FOOTER //
// ./src/roles/rules/common/index.js